<template>
  <div class="time-select-wrapper">
    <table>
      <thead>
        <tr>
          <th>
            <el-checkbox v-model="selectAllRows" @change="toggleAllRows">
              <span style="font-size: 12px">
                {{ $t("components.CustomDayTimePicker.221524-0") }}
              </span>
            </el-checkbox>
          </th>
          <th v-for="hour in hours" :key="hour">{{ hour }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(day, dayIndex) in days" :key="dayIndex">
          <td>
            <el-checkbox v-model="rowSelected[dayIndex]" @change="handleRowChange(dayIndex)">
              <span style="font-size: 12px; margin-right: 4px">
                {{ day }}
              </span>
            </el-checkbox>
          </td>
          <td
            v-for="(hour, hourIndex) in hours"
            :key="hourIndex"
            :class="{ selected: selectedCells[dayIndex][hourIndex] }"
            @click="toggleCell(dayIndex, hourIndex)"
          ></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
  export default {
    props: {
      value: Array // 传入的时间选择数组
    },
    data() {
      return {
        days: [
          this.$t("components.CustomDayTimePicker.221524-1"),
          this.$t("components.CustomDayTimePicker.221524-2"),
          this.$t("components.CustomDayTimePicker.221524-3"),
          this.$t("components.CustomDayTimePicker.221524-4"),
          this.$t("components.CustomDayTimePicker.221524-5"),
          this.$t("components.CustomDayTimePicker.221524-6"),
          this.$t("components.CustomDayTimePicker.221524-7")
        ],
        hours: Array.from({ length: 48 }, (v, i) => {
          const hour = Math.floor(i / 2);
          const minute = (i % 2) * 30;
          return `${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}`;
        }),
        rowSelected: Array(7).fill(false), // 每一行（天）是否全选
        selectedCells: Array(7)
          .fill(0)
          .map(() => Array(48).fill(false)), // 选中的单元格
        selectAllRows: false // 全选标志
      };
    },
    watch: {
      // 监听传入的 value 变化并更新 selectedCells 状态
      value: {
        immediate: true,
        deep: true,
        handler(newValue) {
          if (newValue) {
            this.selectedCells = this.convertValueToSelectedCells(newValue);
            // 更新行和全选状态
            this.rowSelected = this.selectedCells.map(row => row.every(cell => cell));
            this.updateSelectAllRows();
          }
        }
      }
    },
    methods: {
      toggleCell(dayIndex, hourIndex) {
        // 切换单元格的选中状态
        this.$set(this.selectedCells[dayIndex], hourIndex, !this.selectedCells[dayIndex][hourIndex]);

        // 更新行的选中状态
        this.updateRowSelection(dayIndex);
        // 同步数据到父组件
        this.emitSelection();
      },
      updateRowSelection(dayIndex) {
        // 计算行是否全选并更新状态
        const isAllSelected = this.selectedCells[dayIndex].every(item => item);
        this.$set(this.rowSelected, dayIndex, isAllSelected);
        this.updateSelectAllRows();
      },
      handleRowChange(dayIndex) {
        const newState = this.rowSelected[dayIndex];
        this.selectedCells[dayIndex] = this.selectedCells[dayIndex].map(() => newState);

        // 延迟 DOM 更新
        this.$nextTick(() => {
          this.updateSelectAllRows();
          // 同步数据到父组件
          this.emitSelection();
        });
      },
      toggleAllRows(e) {
        // 先更新所有行和单元格的数据
        for (let dayIndex = 0; dayIndex < this.selectedCells.length; dayIndex++) {
          this.selectedCells[dayIndex].fill(e);
          this.$set(this.rowSelected, dayIndex, e);
        }

        // 确保最后才更新 selectAllRows 的状态
        this.selectAllRows = e;

        // 最后更新全选状态
        this.updateSelectAllRows();
        // 同步数据到父组件
        this.emitSelection();
      },
      updateSelectAllRows() {
        // 检查是否所有行都被选中
        this.selectAllRows = this.rowSelected.every(item => item);
      },
      emitSelection() {
        // 生成符合要求的结果，并通过 v-model 同步到父组件
        const result = [];
        this.selectedCells.forEach((daySelection, dayIndex) => {
          daySelection.forEach((isSelected, slotIndex) => {
            if (isSelected) {
              const hour = Math.floor(slotIndex / 2);
              const startMinute = (slotIndex % 2) * 30;
              const endMinute = startMinute + 29;
              const currentStart = `${String(hour).padStart(2, "0")}:${String(startMinute).padStart(2, "0")}:00`;
              const currentEnd = `${String(hour).padStart(2, "0")}:${String(endMinute).padStart(2, "0")}:59`;
              result.push({
                week: dayIndex + 1,
                start: currentStart,
                end: currentEnd
              });
            }
          });
        });
        this.$emit("input", result); // 同步数据
      },
      convertValueToSelectedCells(value) {
        // 将父组件传递的 value 转换成 selectedCells 形式
        const selectedCells = Array(7)
          .fill(0)
          .map(() => Array(48).fill(false));

        value.forEach(item => {
          const dayIndex = item.week - 1;
          const [hourStr, minuteStr] = item.start.split(":");
          const hour = parseInt(hourStr, 10);
          const minute = parseInt(minuteStr, 10);
          const slotIndex = hour * 2 + (minute >= 30 ? 1 : 0);
          if (slotIndex < 48) {
            selectedCells[dayIndex][slotIndex] = true;
          }
        });

        return selectedCells;
      }
    }
  };
</script>

<style scoped>
  .time-select-wrapper {
    font-size: 12px;
    color: #333;
    line-height: 36px;
    overflow-x: auto;
    overflow-y: visible;
    max-width: 100%;
    position: relative;
  }

  table {
    min-width: 100%;
    width: max-content;
    border-collapse: collapse;
  }

  th {
    background-color: #f7f7f7;
    font-weight: normal;
    white-space: nowrap;
    font-size: 11px;
    padding: 4px 2px;
    min-width: 40px;
  }

  th:first-child,
  td:first-child {
    position: sticky;
    left: 0;
    background-color: #fff;
    z-index: 10;
    min-width: 80px;
  }

  th:first-child {
    background-color: #f7f7f7;
    z-index: 11;
  }

  th,
  td {
    border: 1px solid #dcdfe6;
    text-align: center;
    height: 36px;
    transition: background-color 0.3s;
  }

  td {
    cursor: pointer;
    min-width: 40px;
  }

  .selected {
    background-color: var(--vtm-mint);
    color: var(--vtm-navy);
  }

  /* td:hover {
	background-color: #e0f3ff;
} */

  [data-theme="dark"] .time-select-wrapper {
    color: var(--vtm-ink);
  }

  [data-theme="dark"] th,
  [data-theme="dark"] th:first-child {
    background-color: var(--vtm-surface-2);
  }

  [data-theme="dark"] td:first-child {
    background-color: var(--vtm-surface);
  }

  [data-theme="dark"] th,
  [data-theme="dark"] td {
    border-color: var(--vtm-line);
  }
</style>
